import { render, staticRenderFns } from "./HeaderNavBar.vue?vue&type=template&id=f0f0d86e&"
import script from "./HeaderNavBar.vue?vue&type=script&lang=ts&"
export * from "./HeaderNavBar.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNavBar.vue?vue&type=style&index=0&id=f0f0d86e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeaderLogo: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/page/header/PageHeaderLogo.vue').default,HeaderItemCard: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/header/HeaderItemCard.vue').default,CommonSearchBar: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonSearchBar.vue').default})
